export default __webpack_public_path__ + "static/media/Minicard_Ts.ae687837.svg";